import { FactoryProvider } from '@angular/core';
import { ENVIRONMENT, STORAGE_URL } from '@thema-core/tokens';
import { Environment } from '@thema-core/models';

export const STORAGE_URL_PROVIDER: FactoryProvider = {
  provide: STORAGE_URL,
  deps: [ENVIRONMENT],
  useFactory: (env: Environment): string => env.httpSettings.mediaStorageUrl,
};
